"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiProgressBar = getMuiProgressBar;
function getMuiProgressBar() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '.MuiLinearProgress-bar': {
            backgroundColor: theme.palette.primary[600],
            borderRadius: 4
          },
          backgroundColor: theme.palette.gray[200],
          borderRadius: 8,
          height: 8
        };
      }
    }
  };
}